module.exports = "/assets/data/4fd924ea8976f3501d5a30f214bbfa29-WC2E.data.json";